var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_c('v-img',{attrs:{"max-height":"200","contain":"","src":_vm.anno.imageURI}})],1),_c('v-col',{staticClass:"transcription",attrs:{"cols":"6"}},[_c('p',[_vm._v(_vm._s(_vm.anno.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }